module.exports = __webpack_public_path__ + "static/media/sidenav-icon-promocodes.cf844727.svg";